import React, { useEffect } from 'react'
import { Card, Skeleton, Table } from 'antd'
import { formatAmount, formatDate } from 'utils'
import { useDispatch } from 'react-redux'
import { useAuthSelector } from 'store/authSlice/authReducer'
import { useBillingSelector } from 'store/billingSlice/billingReducer'
import { getBillingHistory } from 'store/billingSlice/billingActions'

const columns = [
  {
    title: 'Billing Date',
    dataIndex: 'BillingDate',
    className: 'ant-table-row-cell-break-word',
    render: (_, { BillingDate }) =>
      BillingDate ? formatDate(BillingDate) : null,
  },
  {
    title: 'Charges',
    dataIndex: 'TotalCharges',
    className: 'ant-table-row-cell-break-word',
    render: (_, { TotalCharges }) => formatAmount(TotalCharges),
  },
  {
    title: 'Discount',
    dataIndex: 'Discount',
    className: 'ant-table-row-cell-break-word',
    render: (_, { Discount }) => formatAmount(Discount),
  },
  {
    title: 'Paid',
    dataIndex: 'Payment',
    className: 'ant-table-row-cell-break-word',
    render: (_, { Payment }) => formatAmount(Payment),
  },
]

const BillingHistory = () => {
  const dispatch = useDispatch()
  const { organization } = useAuthSelector()
  const {
    loading: { fetchingHistory },
    history,
  } = useBillingSelector()

  useEffect(() => {
    if (organization?.id) {
      dispatch(getBillingHistory(organization?.id))
    }
  }, [dispatch, organization?.id])

  const isBillingHistoryPresent = history?.length > 1
  return (
    <Card>
      <Skeleton loading={fetchingHistory} active paragraph={{ rows: 8 }}>
        {isBillingHistoryPresent ? (
          <Table
            className="t-w-[300px] sm:t-w-full"
            tableLayout="auto"
            scroll={{ x: 'max-content' }}
            columns={columns}
            dataSource={history || []}
            bordered={false}
            pagination={false}
          />
        ) : (
          <div>No billing history yet</div>
        )}
      </Skeleton>
    </Card>
  )
}

export { BillingHistory }
